import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "inline-block",
    position: "relative",
  },
  content: {
    [theme.breakpoints.up("md")]: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
    },
  },
  custom: {
    display: "flex",
    alignItems: "center",
    marginBottom: 8,
    [theme.breakpoints.up("md")]: {
      marginBottom: 0,
    },
  },
  fromField: {
    flex: "1",
    [theme.breakpoints.up("md")]: {
      width: 128,
    },
  },
  arrowIcon: {
    width: 16,
    height: 16,
    margin: "0 10px",
    color: theme.palette.grey[700],
  },
  toField: {
    flex: "1",
    [theme.breakpoints.up("md")]: {
      width: 128,
    },
  },
  range: {
    position: "relative",
  },
  rangeField: {
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: 140,
      marginLeft: 20,
    },
  },
  message: {
    position: "relative",
    margin: "4px 14px 0 14px",
    fontSize: 12,
    color: theme.palette.error.main,
  },
}));
